<template>
  <div>
    <div class="form-group">
      <label for="ca_business_entity_name" class="col-md-4 control-label">
        {{ $t('Registered company name') }} *
      </label>
      <div class="col-md-6">
        <input
          v-model="caBusinessEntityName"
          class="form-control"
          :placeholder="$t('Registered company name')"
          name="ca_business_entity_name"
          type="text"
        />
      </div>
    </div>
    <div class="form-group">
      <label class="col-md-4 control-label" for="company_no">
        {{ $t('Business number') }}
        <CompanyNumberTooltip market="CA" />
      </label>
      <div class="col-md-3">
        <input
          v-model="caCompanyNo"
          class="form-control"
          :placeholder="$t('Business number')"
          name="ca_company_no"
          type="text"
        />
      </div>
    </div>

    <div class="form-group">
      <div class="col-md-6 col-md-offset-4 col-xs-12">
        <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
        <submit-button :disabled="!canSave" :text="$t('Save')" auto-submit />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable import-x/extensions */
import { deepClone } from '@/utils/tools'
import CompanyNumberTooltip from '@/components/compliances/BusinessEntity/CompanyNumberTooltip.vue'

export default {
  name: 'CompanyCaBusinessEntityForm',
  components: { CompanyNumberTooltip },
  props: {
    businessEntity: {
      type: Object,
      required: true,
    },
  },
  data() {
    const internalBusinessEntity = deepClone(this.businessEntity)
    return {
      internalBusinessEntity,
    }
  },
  computed: {
    caBusinessEntityName: {
      get() {
        return this.internalBusinessEntity.companyName
      },
      set(caBusinessEntityName) {
        this.internalBusinessEntity.companyName = caBusinessEntityName
        this.$emit('update:businessEntity', this.internalBusinessEntity)
      },
    },
    caCompanyNo: {
      get() {
        return this.internalBusinessEntity.companyNo
      },
      set(caCompanyNo) {
        this.internalBusinessEntity.companyNo = caCompanyNo
        this.$emit('update:businessEntity', this.internalBusinessEntity)
      },
    },
    canSave() {
      return this.caBusinessEntityName !== null && this.caBusinessEntityName !== ''
    },
  },
}
</script>
